/**
 * 水池信息路由
 */
const ChiRouter = {
  path: 'chi',
  name: 'Chi',
  meta: {
    requiresAuth: false,
    leftMenu: true          // false表示不需要左边菜单栏
  },
  component: () => import('@/views/Chi/index')
}
export default ChiRouter
